import { render, staticRenderFns } from "./HomeSolutionBox.vue?vue&type=template&id=967c053a&"
import script from "./HomeSolutionBox.vue?vue&type=script&lang=js&"
export * from "./HomeSolutionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports